// Add this debug component to see all available feature IDs
import React, { useEffect } from 'react';
import { usePermissionMatrixData } from '../../redux/services/permissionService';


const FeatureIdDebugger: React.FC = () => {
  const { rolesData, featuresData, isLoading } = usePermissionMatrixData();

  useEffect(() => {
    if (!isLoading && rolesData) {
      
      // Log all feature IDs from roles data
      rolesData.forEach((role, index) => {
        if (role.permissions) {
          const featureIds = Object.keys(role.permissions);
          
          // Log each feature with its permissions
          featureIds.forEach(featureId => {
          });
        }
        console.groupEnd();
      });

      // Log features data if available
      if (featuresData) {
        featuresData.forEach(feature => {

        });
        console.groupEnd();
      }

      console.groupEnd();
    }
  }, [rolesData, featuresData, isLoading]);

  return null;
};

export default FeatureIdDebugger;